import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CompanyInfoCard from "./CompanyInfoCard";
import QuickActions from "./QuickActions";
import AppsServices from "./AppsServices";
import ChildEntities from "./ChildEntities";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEntityDetail,
  fetchEntityLsp,
  fetchGlobalEntityDetails,
} from "../globalEntitiesSlice";
import { getEntityAcess } from "../../settings/users/invite-modal/InviteModalSlice";
import Layout from "../../../Layout";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Skeleton } from "primereact/skeleton";
import LspLinkedContact from "./LspLinkedContact";
import { useFeatureFlag } from "~/config/ff";

const EntityDashboard = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const entityData = useSelector((state) => state.globalEntities.entity_detail);
  const entity_lsp = useSelector((state) => state.globalEntities.entity_lsp);
  const [isFetching, setIsFetching] = useState(true);
  const [loading, setLoading] = useState(true);
  const { role, id: userId } = useSelector((state) => state.login);
  const { userlsp } = useSelector((state) => state.inviteusers);
  const { value: isLspFeatureEnabled } = useFeatureFlag("lsp", false);

  useEffect(() => {
    if ((userId && role === "LSP_USER") || role === "LSP_MANAGER") {
      dispatch(getEntityAcess(userId));
    }
  }, [userId]);
  useEffect(
    () => {
      setLoading(true);
      setIsFetching(true);
      dispatch(fetchEntityDetail(id));
      dispatch(fetchGlobalEntityDetails(id))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
      dispatch(fetchEntityLsp(id))
        .then(() => {
          setIsFetching(false);
        })
        .catch(() => {
          setIsFetching(false);
        });
    },
    [dispatch],
    id,
  );
  const hasEntityPlusAccess = entityData?.active_services?.some(
    (e) => e.name === "Entities +",
  );
  const hasPayrollAccess = entityData?.active_services?.some(
    (e) => e.name === "Payroll",
  );

  return (
    <Layout
      crumbs={[
        { label: "My Entities", url: "/entities", id: "entities" },
        {
          label: (
            <div className="flex">
              {!loading ? (
                entityData?.name
              ) : (
                <Skeleton width="100px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                " "
              ) : (
                <Skeleton width="10px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                <>
                  (
                  <ReactCountryFlag
                    countryCode={entityData?.country || ""}
                    svg
                    className=""
                  />{" "}
                  {getName(entityData?.country || "")})
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </div>
          ),
          id: "entity",
        },
      ]}
      SideNavSection={() => (
        <>
          <div className="sidenav-quick-actions">
            {" "}
            <QuickActions
              hasEntityPlusAccess={hasEntityPlusAccess}
              hasPayrollAccess={hasPayrollAccess}
            />{" "}
          </div>
        </>
      )}
    >
      <div className="entity-dashboard">
        <CompanyInfoCard childEntitiesData={entityData} />
        <AppsServices
          data={entityData}
          load={loading}
          lspserviceurl={userlsp?.service_url_override || []}
        />
        {!loading && entityData?.children?.length > 0 && (
          <ChildEntities childEntitiesData={entityData?.children} />
        )}
        {isLspFeatureEnabled && (
          <LspLinkedContact
            entityLsp={entity_lsp}
            loading={isFetching}
            role={role}
          />
        )}
      </div>
    </Layout>
  );
};
export default EntityDashboard;
